if (!customElements.get("plug-accordion")) {
    class PlugAccordion extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.bodyHeights = [];
            this.items = Array.from(this.getElementsByClassName("plug-accordion__item"));
            this.headings = Array.from(this.getElementsByClassName("plug-accordion__heading"));
            this.bodies = Array.from(this.getElementsByClassName("plug-accordion__body"));
            this.measureBodyHeights();
            this.initListeners();
        }

        measureBodyHeights() {
            const clones = this.bodies.map(answer => {
                const clone = answer.cloneNode(true);
                clone.classList.add("is-measuring");
                clone.style.height = "";
                return answer.parentElement.appendChild(clone);
            });

            afterNextFrame(() => {
                // Measure the clones.
                this.bodyHeights = clones.map(clone => {
                    return clone.getBoundingClientRect().height;
                });
                // Update the current height of any open answers.
                this.bodies.forEach((answer, index) => {
                    if (this.items[index].dataset.open === "true") {
                        answer.style.height = `${this.bodyHeights[index]}px`;
                    }
                });
                // Delete the clones.
                clones.forEach(clone => {
                    clone.parentElement.removeChild(clone);
                });
            });
        }

        initListeners() {
            this.headings.forEach((heading, index) => {
                heading.addEventListener("click", (e) => {
                    if (this.isOpen(index)) {
                        this.close(index);
                    } else {
                        this.open(index);
                    }
                });
            });
            const resizeThrottler = throttlerConstructor(500);
            window.addEventListener("resize", () => {
                resizeThrottler(() => {
                    this.measureBodyHeights();
                });
            });
        }

        open(index) {
            this.items[index].dataset.open = "true";
            this.bodies[index].style.height = `${this.bodyHeights[index]}px`;
        }

        close(index) {
            this.bodies[index].style.height = "";
            this.items[index].dataset.open = "false";
        }

        isOpen(index) {
            return this.headings[index].closest(".plug-accordion__item").dataset.open === "true";
        }
    }

    customElements.define("plug-accordion", PlugAccordion);

    function afterNextFrame(cb) {
        window.requestAnimationFrame(() => {
            setTimeout(cb, 0);
        });
    }

    function throttlerConstructor(delayMs = 0) {
        let queuedCallback;
        return function onEvent(callback) {
            if (!queuedCallback) {
                queuedCallback = callback;
                if (delayMs === 0) {
                    // We are limiting calls to the callback to once per repaint.
                    window.requestAnimationFrame(function () {
                        if (queuedCallback) {
                            const cb = queuedCallback;
                            queuedCallback = null;
                            cb();
                        }
                    });
                } else {
                    // We are limiting the calls to the callback to some specific interval of time.
                    setTimeout(() => {
                        if (queuedCallback) {
                            const cb = queuedCallback;
                            queuedCallback = null;
                            cb();
                        }
                    }, delayMs);
                }
            } else {
                queuedCallback = callback;
            }
        };
    }
}